"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _fns = require("@react-pdf/fns");
/**
 * Append glyph indices with given length
 *
 * Ex. appendIndices(3, [0, 1, 2, 2]) => [0, 1, 2, 2, 3, 3, 3]
 *
 * @param  {number}  length
 * @param  {Array}  glyph indices
 * @return {Array}  extended glyph indices
 */


var appendIndices = function appendIndices(length, indices) {
  var lastIndex = (0, _fns.last)(indices);
  var value = (0, _fns.isNil)(lastIndex) ? 0 : lastIndex + 1;
  var newIndices = Array(length).fill(value);
  return indices.concat(newIndices);
};

var _default = appendIndices;
exports["default"] = _default;